import React from 'react';
import { UrgencyBanner } from './components/UrgencyBanner';
import { Hero } from './components/Hero';
import { InitialTestimonials, MoreTestimonials } from './components/Testimonials';
import { PainPoints } from './components/PainPoints';
import { PackContents } from './components/PackContents';
import { Pricing } from './components/Pricing';
import { FAQ } from './components/FAQ';
import { Guarantee, Footer } from './components/Footer';
import { FloatingNotification } from './components/FloatingNotification';
import { EmotionalClose } from './components/EmotionalClose';
import { FretDivider } from './components/Ornaments';
const TransitionPhrase = () => <div className="mx-auto max-w-3xl px-6 py-6 text-center" data-id="element-0" data-mp="31ctbbg5tvg3d">
    <FretDivider character="次" data-id="element-1" data-mp="2wj8cxn0bok3n" />
    <p className="mt-4 font-display text-xl font-bold italic leading-relaxed text-brand-burgundy/90 md:text-3xl" data-id="element-2" data-mp="2whxb3sqftmf6">
      La próxima sesión puede ser diferente.
    </p>
  </div>;
export function App() {
  return <div className="rice-paper min-h-screen font-sans text-brand-text selection:bg-brand-burgundy/20 selection:text-brand-burgundyDark" data-id="element-3" data-mp="23ti5fwt74ggi">
      <UrgencyBanner data-id="element-4" data-mp="3mkrgdsxitvh0" />
      <Hero data-id="element-5" data-mp="3mjzs7369700r" />
      <PackContents data-id="element-6" data-mp="3mjq45l4rr2xp" />
      <InitialTestimonials data-id="element-7" data-mp="3rc9em985thya" />
      <PainPoints data-id="element-8" data-mp="3rbzn2h7gv2qh" />
      <div className="mx-auto w-full max-w-7xl px-4 sm:px-6 lg:px-8" data-id="element-9" data-mp="3rdkhm6ts6loc">
        <Pricing data-id="element-10" data-mp="6hr7hlrojf6" />
      </div>
      <MoreTestimonials data-id="element-11" data-mp="4n5w26l2pak" />
      <Guarantee data-id="element-12" data-mp="82ld64660ci" />
      <FAQ data-id="element-13" data-mp="2zl3a7gleoy37" />
      <TransitionPhrase data-id="element-14" data-mp="2zld2jatxbhc2" />
      <EmotionalClose data-id="element-15" data-mp="2zm4ywnvchj3e" />
      <Footer data-id="element-16" data-mp="2zmo5x9jgin2n" />
      <FloatingNotification data-id="element-17" data-mp="2zn6biws0edn8" />
    </div>;
}